export default () => {
  return {
    theme: 'dark',
    open: false,
    icon: 'burger',
    gradientClass: '',
    openMenu() {
      this.open = true
      this.icon = 'x'
    },
    closeMenu() {
      this.open = false
      this.icon = 'burger'
    },
    get isDarkTheme() {
      return this.theme === 'dark'
    },
    changeTheme(theme, pageLoad) {
      this.gradientClass = ''
      this.theme = theme
      setTimeout(() => {
        if(!pageLoad) {
          this.closeMenu()
        }
      }, 2000)
      setTimeout(() => {
        this.gradientClass = theme === 'dark' ? 'dark-gradient' : 'white-gradient'
      }, 3000)
    },
  }
}
